/**
 * localStorage cache for non-sensitive UI session hints.
 * This is NOT encryption. Tokens, emails, and other PII must not be written here.
 */

const USER_CACHE_KEY = 'style_ai_user'
const PREMIUM_CACHE_KEY = 'style_ai_premium'

const SENSITIVE_OMIT = [
  'email',
  'firstName',
  'lastName',
  'phone',
  'photoURL',
  'address',
  'city',
  'state',
  'zipCode',
  'country',
  'billingInfo',
  'stripeCustomerId',
  'stripeSubscriptionId',
  'age',
  'gender',
  'height',
  'weight',
  'chest',
  'waist',
  'hips',
  'inseam',
  'shoulder',
  'sleeve',
  'neck',
  'shoeSize',
  'creditCard',
  'cvv',
  'expiryDate'
]

function normalizeIsAdmin(value) {
  return value === true
}

function toSessionCache(data) {
  if (data == null || typeof data !== 'object') return data
  const cache = { ...data }
  for (const key of SENSITIVE_OMIT) delete cache[key]
  if (!cache.isLocalDevSession) delete cache.name
  if ('isAdmin' in cache) cache.isAdmin = normalizeIsAdmin(cache.isAdmin)
  return cache
}

function isLegacyXorWrapper(parsed) {
  return (
    parsed &&
    typeof parsed === 'object' &&
    !Array.isArray(parsed) &&
    Object.prototype.hasOwnProperty.call(parsed, 'checksum') &&
    Object.prototype.hasOwnProperty.call(parsed, 'data')
  )
}

class SessionCache {
  cacheSet(key, data) {
    try {
      if (data === null || data === undefined) {
        localStorage.removeItem(key)
        return true
      }
      const payload = key === USER_CACHE_KEY ? toSessionCache(data) : data
      localStorage.setItem(key, JSON.stringify(payload))
      return true
    } catch (error) {
      console.error('Session cache write failed:', error)
      return false
    }
  }

  cacheGet(key) {
    try {
      const stored = localStorage.getItem(key)
      if (!stored) return null
      const parsed = JSON.parse(stored)
      if (isLegacyXorWrapper(parsed)) {
        localStorage.removeItem(key)
        return null
      }
      return key === USER_CACHE_KEY ? toSessionCache(parsed) : parsed
    } catch (error) {
      console.error('Session cache read failed:', error)
      try {
        localStorage.removeItem(key)
      } catch (_) {}
      return null
    }
  }

  // Back-compat names used by UserContext — still a cache, not encryption.
  secureStore(key, data) {
    return this.cacheSet(key, data)
  }

  secureRetrieve(key) {
    return this.cacheGet(key)
  }
}

const securityService = new SessionCache()

export default securityService
export { USER_CACHE_KEY, PREMIUM_CACHE_KEY, toSessionCache, normalizeIsAdmin }
